import React, { useEffect } from 'react';
import { Autocomplete, Checkbox, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import ReactQuill from 'react-quill';
import { StatusDropdownType } from './Notifycandidate';
import { emailTemplate, PannelMembersType } from '../../CandidateContent/CandidateContent';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

interface StakeholderTabContentProps {
  email: string | null;
  status: string | null;
  subject: string;
  message: string;
  handleStatusChange: (event: SelectChangeEvent<string>) => void;
  setSubject: (value: string) => void;
  setMessage: (value: string) => void;
  statusDropdown: StatusDropdownType[];
  pannelMembersdropdown: PannelMembersType[];
  selectedStakeholders: string[];
  setSelectedStakeholders: (value: string[]) => void;
  emailData: emailTemplate[];
  setStatus: (value: string | null) => void
}

const StakeholderTabContent: React.FC<StakeholderTabContentProps> = ({
  email,
  status,
  subject,
  message,
  handleStatusChange,
  setSubject,
  setMessage,
  statusDropdown,
  pannelMembersdropdown,
  selectedStakeholders,
  setSelectedStakeholders,
  emailData,
  setStatus
}) => {

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  // useEffect(() => {
  //   if (emailData.length > 0 && !st) {
  //     const firstTemplate = emailData[0];

  //     const fakeEvent = {
  //       target: { value: firstTemplate.EmailSubject }
  //     } as SelectChangeEvent<string>;

  //     handleStatusChange(fakeEvent);
  //   } else {
  //     setStatus('');
  //     setSubject('');
  //     setMessage('');
  //   }
  // }, [emailData]);

  useEffect(() => {
    setSelectedStakeholders([])
  }, [])

  return (
    <>
      <FormControl fullWidth margin="dense" sx={{ mt: '2vh' }} required>
        <Autocomplete
          multiple
          disableCloseOnSelect
          options={pannelMembersdropdown.filter(
            (member) => member.RoleName?.toLowerCase() === 'stakeholder'
          )}
          getOptionLabel={(option) => option.EmailId}
          value={[]} // empty array to hide selected chips
          onChange={(_, __) => { }} // we will override click below
          renderOption={(props, option) => {
            const isSelected = selectedStakeholders.includes(option.EmailId);

            return (
              <li
                {...props}
                onClick={() => {
                  const updated = isSelected
                    ? selectedStakeholders.filter((email) => email !== option.EmailId)
                    : [...selectedStakeholders, option.EmailId];
                  setSelectedStakeholders(updated);
                }}
              >
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  checked={isSelected}
                />
                <Typography variant="body2">{option.EmailId}</Typography>
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Stakeholder"
              size="small"
              placeholder="Select Stakeholders"
            />
          )}
          noOptionsText="No stakeholders available"
        />
      </FormControl>



      <FormControl fullWidth margin="dense" required>
        <InputLabel size="small">Status</InputLabel>
        <Select
          size="small"
          value={status ?? ""}
          onChange={handleStatusChange}
          label="Status"
        >
          {emailData.map((template) => (
            <MenuItem key={template.EmailNum} value={template.EmailKey}>
              {template.EmailSubject}
            </MenuItem>
          ))}
        </Select>
      </FormControl>



      {/* Subject */}
      <TextField
        label="Subject"
        size="small"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        fullWidth
        sx={{ marginY: '2vh' }}
        required
        error={!subject}
        helperText={!subject ? 'Subject is required' : ''}
      />

      {/* Message */}
      <ReactQuill
        value={message}
        onChange={setMessage}
        style={{ height: '30vh', marginTop: '1vh' }}
        modules={{
          toolbar: [['bold', 'italic', 'link', { list: 'ordered' }, { list: 'bullet' }]],
        }}
      />
    </>
  );
};

export default StakeholderTabContent;
